var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 220,
    viewBox: "0 0 229 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3349_11620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.46 94.9984L96.6279 98.3296L92.3516 29.2259L132.322 26.7524L146.999 39.062L150.46 94.9984Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.321 26.7524L146.998 39.062L133.136 39.9198L132.321 26.7524Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.399 73.2467L117.191 71.6881C116.647 68.4573 117.532 64.8443 120.34 61.0638C122.87 57.7211 124.244 55.2885 124.092 52.5798C123.921 49.5093 121.879 47.5701 118.083 47.7222C115.915 47.8437 113.548 48.7009 112.106 49.9293L110.449 46.2169C112.355 44.6608 115.733 43.5054 118.923 43.3264C125.847 42.9385 129.216 47.0382 129.473 51.6131C129.702 55.7075 127.58 58.7853 124.882 62.379C122.409 65.6579 121.594 68.3613 121.946 71.4213L122.094 72.9832L117.399 73.2467ZM116.546 81.7494C116.422 79.5217 117.839 77.872 119.946 77.7539C122.053 77.6358 123.586 79.1205 123.71 81.3481C123.829 83.4553 122.535 85.1584 120.307 85.2832C118.201 85.4013 116.664 83.8566 116.546 81.7494Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5 219.5C177.737 219.5 229 212.784 229 204.5C229 196.216 177.737 189.5 114.5 189.5C51.2634 189.5 0 196.216 0 204.5C0 212.784 51.2634 219.5 114.5 219.5Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.132 207.385H41.8857L63.0326 87.4562H209.278L188.132 207.385Z",
    fill: "#B9E6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.085 75.0361H65.222L63.0322 87.4561H114.254L113.085 75.0361Z",
    fill: "#B9E6DB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.132 207.385H41.8857L63.0326 87.4562H209.278L188.132 207.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.085 75.0361H65.222L63.0322 87.4561H114.254L113.085 75.0361Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.0574 80.1027C59.8683 79.4067 59.8255 78.7103 59.8174 78.0143C59.8241 77.3178 59.8668 76.6218 60.0574 75.9258C60.2475 76.6218 60.2902 77.3183 60.2974 78.0143C60.2892 78.7107 60.2465 79.4067 60.0574 80.1027Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8045 81.333C55.2924 80.8247 54.9074 80.2429 54.5527 79.6443C54.2105 79.0381 53.8994 78.4136 53.7161 77.7157C54.2292 78.2235 54.6141 78.8053 54.9679 79.4043C55.3092 80.0111 55.6207 80.6355 55.8045 81.333Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7362 84.5245C52.0387 84.3402 51.4143 84.0292 50.8075 83.6879C50.208 83.3336 49.6263 82.9487 49.1189 82.436C49.8168 82.6194 50.4413 82.9304 51.0475 83.2727C51.6461 83.6279 52.2278 84.0124 52.7362 84.5245Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.675 88.8229C50.979 89.012 50.2825 89.0547 49.5865 89.0629C48.8905 89.0557 48.194 89.0134 47.498 88.8229C48.194 88.6328 48.8905 88.5901 49.5865 88.5829C50.2825 88.591 50.9785 88.6338 51.675 88.8229Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9044 93.0762C52.3961 93.5883 51.8143 93.9733 51.2158 94.328C50.6095 94.6703 49.985 94.9813 49.2871 95.1647C49.7949 94.652 50.3767 94.2671 50.9758 93.9128C51.5825 93.5715 52.207 93.26 52.9044 93.0762Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0963 96.1445C55.912 96.842 55.6009 97.4664 55.2597 98.0732C54.9054 98.6727 54.5205 99.2544 54.0078 99.7618C54.1912 99.0639 54.5022 98.4394 54.8444 97.8332C55.1992 97.2346 55.5841 96.6529 56.0963 96.1445Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3943 97.2056C60.5834 97.902 60.6261 98.598 60.6343 99.294C60.6271 99.99 60.5849 100.687 60.3943 101.383C60.2037 100.687 60.1615 99.99 60.1543 99.294C60.1625 98.598 60.2052 97.902 60.3943 97.2056Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6484 95.9761C65.1606 96.4844 65.5451 97.0661 65.9003 97.6647C66.2425 98.2709 66.5536 98.8954 66.7369 99.5934C66.2238 99.0855 65.8393 98.5037 65.4851 97.9047C65.1438 97.2975 64.8328 96.6735 64.6484 95.9761Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7158 92.7837C68.4133 92.968 69.0377 93.2791 69.6445 93.6203C70.244 93.9746 70.8257 94.3595 71.3331 94.8722C70.6352 94.6888 70.0107 94.3778 69.4045 94.0355C68.8059 93.6808 68.2241 93.2959 67.7158 92.7837Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7783 88.4856C69.4743 88.2965 70.1708 88.2538 70.8668 88.2456C71.5628 88.2528 72.2593 88.295 72.9553 88.4856C72.2588 88.6757 71.5628 88.7184 70.8668 88.7256C70.1703 88.7174 69.4743 88.6752 68.7783 88.4856Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5476 84.2326C68.0559 83.7205 68.6377 83.3355 69.2362 82.9808C69.8425 82.6391 70.467 82.3275 71.1649 82.1442C70.657 82.6568 70.0753 83.0418 69.4762 83.396C68.8695 83.7373 68.245 84.0483 67.5476 84.2326Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3564 81.1646C64.5408 80.4672 64.8518 79.8427 65.1931 79.236C65.5473 78.6365 65.9323 78.0547 66.4449 77.5474C66.2616 78.2453 65.9505 78.8698 65.6083 79.476C65.2531 80.0746 64.8681 80.6563 64.3564 81.1646Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.917 207.385H41.3563L20.5479 91.8097H167.109L187.917 207.385Z",
    fill: "#B9E6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3339 162.462C74.6982 162.462 77.4255 159.734 77.4255 156.37C77.4255 153.006 74.6982 150.278 71.3339 150.278C67.9695 150.278 65.2422 153.006 65.2422 156.37C65.2422 159.734 67.9695 162.462 71.3339 162.462Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.49 162.462C122.854 162.462 125.582 159.734 125.582 156.37C125.582 153.006 122.854 150.278 119.49 150.278C116.126 150.278 113.398 153.006 113.398 156.37C113.398 159.734 116.126 162.462 119.49 162.462Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.162 163.434L103.828 162.796C103.797 162.739 100.65 156.922 94.3183 156.922C88.5434 156.922 87.1356 162.399 87.0784 162.632L86.9075 163.33L85.5107 162.992L85.6787 162.294C85.6951 162.226 87.3947 155.482 94.3183 155.482C101.536 155.482 104.961 161.856 105.103 162.128L105.437 162.766L104.162 163.434Z",
    fill: "#263238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3349_11620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 219,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceDisabled);
export default __webpack_public_path__ + "static/media/attendance-disabled.75931e51ddd9791d8c5381c222f5abcb.svg";
export { ForwardRef as ReactComponent };